import React, {useEffect, useState} from 'react';
import {motion} from "framer-motion";
import "./coreLoaderStyle.css"

const CoreLoader = ({ onFinish }) => {

    const pathData1 = "M126.942 210.372C126.677 210.676 126.412 210.981 126.138 211.294C125.579 211.935 125.018 212.575 124.455 213.213C123.618 214.167 122.788 215.126 121.959 216.087C107.876 232.227 87.2434 245.767 64.4567 248.133C63.5475 248.258 63.5475 248.258 62.62 248.385C42.8138 250.903 21.058 246.974 2.87377 235.321C1.89471 234.621 0.941791 233.883 1.10743e-05 233.132C0.235442 232.865 0.470872 232.597 0.71345 232.321C1.90744 232.572 3.09579 232.88 4.27869 233.211C8.28118 234.248 12.0598 234.76 16.0942 235.067C16.9028 235.137 17.7114 235.208 18.5201 235.279C26.8182 235.994 34.4353 235.68 42.4549 234.527C43.1449 234.431 43.8349 234.335 44.5458 234.237C48.7854 233.601 52.7049 232.575 56.6854 231.225C57.7206 230.898 57.7206 230.898 58.7768 230.564C68.8776 227.301 77.9861 222.521 86.1365 216.141C86.6889 215.72 87.2414 215.298 87.8105 214.864C108.454 198.196 119.529 172.124 121.29 144.937C121.318 144.524 121.346 144.11 121.375 143.685C121.696 138.698 121.754 133.74 121.53 128.684C121.546 127.18 121.546 127.18 122.259 126.369C121.958 126.104 121.657 125.84 121.347 125.567C121.202 124.306 121.202 124.306 121.152 122.743C121.08 120.873 120.974 119.046 120.696 117.172C120.514 115.483 120.514 115.483 121.227 114.672C121.051 114.333 120.875 113.993 120.694 113.644C120.064 112.13 119.904 110.958 119.764 109.383C119.328 105.459 118.459 101.634 117.519 97.7425C117.429 97.3643 117.339 96.986 117.246 96.5962C108.226 58.8984 84.9565 27.4295 56.3041 -6.86967e-06C59.3653 0.313239 61.7645 1.40165 64.6189 2.73126C65.1455 2.97611 65.6721 3.22097 66.2146 3.47323C78.5174 9.3358 89.7938 16.9426 100.063 26.0538C100.441 26.3877 100.819 26.7217 101.209 27.0657C121.382 44.9346 136.754 67.1768 145.267 91.9494C145.409 92.3528 145.552 92.7563 145.699 93.172C147.967 99.5978 149.466 105.922 150.64 112.502C150.836 113.545 150.836 113.545 151.036 114.609C153.686 129.011 153.925 143.067 151.204 156.861C150.986 157.976 150.789 159.097 150.595 160.219C147.634 176.095 140.571 190.237 132.138 203.394C131.767 203.978 131.396 204.562 131.014 205.164C129.79 207.017 128.401 208.707 126.942 210.372Z"
    const pathData2 = "M235.913 0C239.111 3.28467 237.792 11.281 237.796 15.7342C237.797 16.1954 237.798 16.6567 237.798 17.132C237.791 25.4108 237.238 33.4836 235.913 41.6602C235.787 42.447 235.787 42.447 235.659 43.2498C232.293 63.6507 224.568 83.5221 212.387 100.066C211.817 100.841 211.254 101.622 210.697 102.407C209.005 104.779 207.27 106.873 205.196 108.912C204.428 109.718 203.661 110.527 202.896 111.336C197.939 116.536 193.036 121.389 187.23 125.576C186.812 125.889 186.394 126.203 185.964 126.526C172.327 136.622 156.72 142.315 140.286 145.216C139.873 145.294 139.459 145.372 139.034 145.452C120.639 148.848 100.477 146.484 82.9097 140.454C82.4349 140.292 81.96 140.13 81.4708 139.964C52.3234 129.857 26.0559 108.366 11.6242 80.3447C11.4307 79.9708 11.2372 79.5969 11.0379 79.2116C2.17975 61.7987 -3.45366 37.547 2.39204 18.1798C2.56985 17.6796 2.74766 17.1794 2.93085 16.6641C3.31336 16.8605 3.69587 17.0569 4.08996 17.2592C4.34437 18.4322 4.34437 18.4322 4.50199 19.9769C4.56452 20.5436 4.62704 21.1102 4.69145 21.6941C4.75594 22.305 4.82042 22.916 4.88686 23.5455C6.94833 40.9924 13.026 57.075 23.7949 70.8223C24.1617 71.3195 24.5285 71.8166 24.9065 72.3288C30.2004 79.4128 36.5037 85.216 43.4999 90.4622C43.8273 90.7089 44.1547 90.9556 44.492 91.2099C65.9119 107.13 93.0887 116.171 119.422 117.244C120.02 117.275 120.617 117.307 121.233 117.339C145.318 118.023 168.98 109.125 187.81 94.033C188.347 93.6142 188.885 93.1953 189.44 92.7637C196.791 86.855 203.381 79.9054 208.674 72.0126C209.099 71.4104 209.524 70.8082 209.962 70.1877C224.512 49.3006 231.858 25.0594 235.913 0Z"
    const pathData3 = "M157.417 11.2652C157.799 11.8544 158.182 12.4436 158.576 13.0506C158.088 13.0077 157.6 12.9647 157.097 12.9205C128.975 10.7613 102.975 15.4332 81.087 34.6619C79.6523 35.9634 78.251 37.2934 76.8581 38.6419C76.2283 39.2311 76.2283 39.2311 75.5858 39.8322C71.7003 43.6077 68.5913 47.9428 65.48 52.389C64.8003 53.3594 64.1098 54.3219 63.4173 55.2827C47.9357 77.7005 43.5733 108.08 47.844 134.795C50.6947 151.029 56.5765 167.03 65.9619 180.484C67.0056 182.072 67.0056 182.072 67.0056 183.262C67.3881 183.262 67.7706 183.262 68.1647 183.262C68.6949 184.058 69.2196 184.858 69.7245 185.671C73.1028 190.849 77.328 195.416 81.4945 199.926C81.7695 200.226 82.0446 200.525 82.3279 200.834C86.7238 205.59 91.4261 209.725 96.563 213.615C97.1779 214.08 97.7927 214.546 98.4262 215.026C103.203 218.524 108.2 221.492 113.37 224.327C113.74 224.532 114.109 224.737 114.49 224.948C132.477 234.842 153.265 240.647 173.644 241.587C174.279 241.617 174.279 241.617 174.927 241.648C193.032 242.392 210.7 238.742 227.396 231.639C229.282 230.874 229.282 230.874 230.441 230.874C230.441 231.267 230.441 231.66 230.441 232.064C229.619 232.798 229.619 232.798 228.469 233.617C228.048 233.92 227.627 234.222 227.193 234.533C226.747 234.848 226.3 235.162 225.84 235.486C225.201 235.944 225.201 235.944 224.549 236.412C223.234 237.351 221.911 238.278 220.588 239.206C220.169 239.508 219.75 239.81 219.318 240.121C216.049 242.436 212.659 244.276 209.07 246.013C208.194 246.438 208.194 246.438 207.302 246.871C195.946 252.301 184.11 256.045 171.797 258.4C171.33 258.489 170.864 258.579 170.383 258.672C161.433 260.277 152.472 260.859 143.398 260.817C142.664 260.816 142.664 260.816 141.915 260.814C133.843 260.784 125.961 260.354 118.007 258.846C117.464 258.744 116.922 258.642 116.363 258.536C103.575 256.047 91.0969 252.321 79.1763 246.943C78.6858 246.723 78.1954 246.503 77.69 246.276C55.3077 236.11 34.4124 219.967 20.2717 199.295C19.5154 198.19 18.7407 197.101 17.9628 196.011C2.74097 174.188 -2.79683 144.79 1.31243 118.457C1.37948 118.043 1.44653 117.628 1.51561 117.201C1.58416 116.764 1.6527 116.326 1.72333 115.875C5.80825 90.6106 16.2759 66.1262 32.2321 46.3788C32.5952 45.8962 32.9583 45.4137 33.3324 44.9165C39.6399 36.6402 47.1269 29.3186 55.4144 23.1681C56.0323 22.7063 56.6501 22.2444 57.2867 21.7686C85.4087 1.29693 126.369 -9.64697 157.417 11.2652Z"
    const pathData4 = "M60.1745 243.256C55.2019 243.423 50.0775 236.509 46.6577 233.253C46.3033 232.916 45.9489 232.579 45.5838 232.231C39.2369 226.166 33.4666 219.812 28.2088 212.762C27.7013 212.085 27.7014 212.085 27.1837 211.394C14.1106 193.756 4.78625 173.002 1.43083 151.104C1.27297 150.078 1.10512 149.054 0.929745 148.032C0.406815 144.936 0.130482 142.009 0.156051 138.85C0.126552 137.642 0.0938563 136.434 0.0589562 135.227C-0.130614 127.437 0.0961552 120.286 1.33495 112.556C1.41469 111.991 1.7528 110.638 1.83496 110.056C4.54287 91.7068 11.9607 76.3859 22.335 61.0558C22.5918 60.6665 23.5703 59.4569 23.835 59.0558C35.3326 41.7876 51.7406 27.7596 69.835 18.0558C70.3233 17.7928 71.3318 17.3269 71.835 17.0558C101.936 1.02983 137.914 -4.71639 170.479 4.19687C170.914 4.31507 171.35 4.43326 171.798 4.55503C191.95 10.1822 214.877 23.4067 225.256 42.281C225.503 42.79 225.751 43.299 226.006 43.8235C225.562 43.9871 225.118 44.1508 224.661 44.3194C223.565 43.6652 223.565 43.6652 222.259 42.6612C221.777 42.2967 221.294 41.9321 220.797 41.5566C220.278 41.1612 219.76 40.7658 219.226 40.3584C204.259 29.2443 187.259 22.3564 168.455 20.948C167.792 20.8789 167.129 20.8098 166.447 20.7386C156.952 19.8077 147.667 20.6255 138.278 22.4078C137.838 22.4903 137.398 22.5728 136.944 22.6579C108.307 28.219 82.3464 44.1784 61.335 64.5558C60.8526 65.0131 59.3319 66.5847 58.835 67.0558C39.8456 85.9109 29.6909 109.047 26.835 135.227C26.744 135.965 26.309 138.089 26.2153 138.85C25.1133 149.083 24.2168 158.525 26.2153 168.556C26.3515 169.338 26.6946 170.25 26.835 171.056C31.7067 198.038 44.0553 221.655 60.1745 243.256Z"
    const pathData5 = "M215.826 67.5934C216.014 67.9692 216.202 68.3451 216.396 68.7324C216.791 69.5253 217.185 70.3189 217.578 71.1132C218.165 72.2971 218.76 73.4766 219.356 74.6562C229.321 94.6129 234.7 119.597 229.155 141.891C228.962 142.793 228.962 142.793 228.764 143.713C224.366 163.285 213.426 181.966 196.646 194.057C195.677 194.677 194.681 195.257 193.677 195.821C193.513 195.489 193.348 195.156 193.179 194.813C193.811 193.803 194.494 192.822 195.196 191.855C197.495 188.551 199.239 185.235 200.883 181.593C201.221 180.867 201.559 180.141 201.898 179.415C205.355 171.96 207.643 164.708 209.302 156.727C209.448 156.042 209.594 155.357 209.745 154.651C210.598 150.421 210.987 146.326 211.101 142.037C211.152 140.932 211.152 140.932 211.205 139.804C211.643 128.99 210.361 118.464 207.295 108.161C207.097 107.467 206.899 106.773 206.695 106.058C198.466 79.7477 178.422 58.422 154.212 45.3321C153.844 45.132 153.477 44.9319 153.098 44.7257C148.656 42.3263 144.153 40.1851 139.464 38.2658C138.097 37.6186 138.097 37.6186 137.598 36.6105C137.255 36.7803 136.912 36.9501 136.558 37.125C135.359 36.7304 135.359 36.7304 133.916 36.1184C132.185 35.3994 130.482 34.7295 128.678 34.1998C127.075 33.6593 127.075 33.6593 126.577 32.6512C126.208 32.6728 125.839 32.6944 125.458 32.7166C123.864 32.668 122.741 32.3244 121.256 31.7929C117.528 30.5482 113.745 29.7502 109.877 28.9909C109.501 28.9159 109.125 28.8409 108.738 28.7636C71.293 21.326 34.7137 29.8288 0.000202052 45.0631C1.32092 42.3337 3.12511 40.5494 5.30326 38.4412C5.70469 38.0521 6.10613 37.663 6.51971 37.262C16.028 28.2309 26.7808 20.8932 38.5658 15.1298C38.9983 14.917 39.4308 14.7043 39.8764 14.4851C63 3.15176 88.4909 -1.85323 113.972 0.61786C114.388 0.654239 114.804 0.69062 115.233 0.728103C121.863 1.31294 128.14 2.57388 134.54 4.24677C135.558 4.50273 135.558 4.50273 136.597 4.76386C150.633 8.3487 163.539 14.0427 175.205 22.3919C176.149 23.0649 177.105 23.7207 178.063 24.3743C191.547 33.8251 202.063 46.3789 211.216 59.7995C211.623 60.392 212.031 60.9845 212.451 61.595C213.728 63.5186 214.801 65.5282 215.826 67.5934Z"
    const topCircleAnimationTime = 2;
    const bgSvgColor = "white";
    const svg1delay = 1;
    const svg2delay = 2.1;
    const svg3delay = 3;
    const svg4delay = 4.1;
    const svg5delay = 5;

    const [loading, setLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    const [svgReady, setSvgReady] = useState(false);

    useEffect(() => {
        requestAnimationFrame(() => setSvgReady(true));
    }, []);

    useEffect(() => {
        if (!svgReady) return;

        const runLoader = async () => {
            if (document.fonts) {
                try {
                    await document.fonts.ready;
                } catch (e) {
                    console.warn("Fonts failed to load", e);
                }
            }

            const MIN_DURATION = 0;
            await new Promise(res => setTimeout(res, MIN_DURATION));

            setFadeOut(true);

            setTimeout(() => {
                setLoading(false);
                if (onFinish) onFinish();
            }, 500);
        };

        runLoader();
    }, [svgReady, onFinish]);

    if (!loading) return null;

    return (
        <div className={`logo-loader ${fadeOut ? "hide" : ""}`}>
            <div className="logo_center_block" style={{ opacity: svgReady ? 1 : 0 }}>

                <svg className="core_svg1" width="154" height="250" viewBox="0 0 154 250">
                    <defs>
                        <motion.linearGradient
                            id="movingGradient"
                            gradientUnits="userSpaceOnUse"
                            x1="-70"
                            y1="-70"
                            x2="248"
                            y2="258"
                        >
                            <animateTransform
                                attributeName="gradientTransform"
                                type="rotate"
                                values="-10 100 100; 80 100 100; 180 100 100"
                                dur={`${topCircleAnimationTime}s`}
                                repeatCount="indefinite"
                                calcMode="linear"
                                begin={`${svg1delay}s`}
                            />
                            <motion.stop
                                offset="0%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "-30%" }}
                                animate={{ offset: ["-50%", "130%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg1delay }}
                            />
                            <motion.stop
                                offset="20%"
                                stopColor="#bbbbbb"
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["0%", "160%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg1delay }}
                            />
                            <motion.stop
                                offset="100%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "30%" }}
                                animate={{ offset: ["30%", "190%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg1delay }}
                            />
                        </motion.linearGradient>
                    </defs>

                    <motion.path d={pathData1} fill="url(#movingGradient)" />
                </svg>

                <svg className="core_svg2" width="239" height="148" viewBox="0 0 239 148">
                    <defs>
                        <motion.linearGradient
                            id="movingGradient2"
                            gradientUnits="userSpaceOnUse"
                            x1="218"
                            y1="300"
                            x2="-70"
                            y2="-70"
                        >
                            <animateTransform
                                attributeName="gradientTransform"
                                type="rotate"
                                values="-140 100 100; 0 100 100; 10 100 100"
                                dur={`${topCircleAnimationTime}s`}
                                repeatCount="indefinite"
                                calcMode="linear"
                                begin={`${svg2delay}s`}
                            />
                            <motion.stop
                                offset="0%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "-30%" }}
                                animate={{ offset: ["-30%", "130%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg2delay }}
                            />
                            <motion.stop
                                offset="50%"
                                stopColor="#bbbbbb"
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["0%", "130%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg2delay }}
                            />
                            <motion.stop
                                offset="100%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "30%" }}
                                animate={{ offset: ["30%", "180%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg2delay }}
                            />
                        </motion.linearGradient>
                    </defs>

                    <motion.path d={pathData2} fill="url(#movingGradient2)" />
                </svg>


                <svg className="core_svg3" width="231" height="261" viewBox="0 0 231 261">
                    <defs>
                        <motion.linearGradient
                            id="movingGradient3"
                            gradientUnits="userSpaceOnUse"
                            x1="250"
                            y1="250"
                            x2="-50"
                            y2="-50"
                        >
                            <animateTransform
                                attributeName="gradientTransform"
                                type="rotate"
                                values="-10 100 100; 55 100 100; 170 100 100"
                                dur={`${topCircleAnimationTime}s`}
                                repeatCount="indefinite"
                                calcMode="linear"
                                begin={`${svg3delay}s`}
                            />
                            <motion.stop
                                offset="0%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "-30%" }}
                                animate={{ offset: ["-30%", "100%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg3delay }}
                            />
                            <motion.stop
                                offset="50%"
                                stopColor="#bbbbbb"
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["-10%", "120%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg3delay }}
                            />
                            <motion.stop
                                offset="100%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "30%" }}
                                animate={{ offset: ["0%", "190%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg3delay }}
                            />
                        </motion.linearGradient>
                    </defs>

                    <motion.path d={pathData3} fill="url(#movingGradient3)" />
                </svg>


                <svg className="core_svg4" width="226" height="244" viewBox="0 0 226 244">
                    <defs>
                        <motion.linearGradient
                            id="movingGradient4"
                            gradientUnits="userSpaceOnUse"
                            x1="0"
                            y1="258"
                            x2="248"
                            y2="0"

                        >
                            <animateTransform
                                attributeName="gradientTransform"
                                type="rotate"
                                values="-10 100 100; 0 100 100; 20 100 100"
                                dur={`${topCircleAnimationTime}s`}
                                repeatCount="indefinite"
                                calcMode="linear"
                                begin={`${svg4delay}s`}
                            />
                            <motion.stop
                                offset="0%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "-30%" }}
                                animate={{ offset: ["-50%", "130%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg4delay }}
                            />
                            <motion.stop
                                offset="50%"
                                stopColor="#bbbbbb"
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["-20%", "160%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg4delay }}
                            />
                            <motion.stop
                                offset="100%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["0%", "190%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg4delay }}
                            />
                        </motion.linearGradient>
                    </defs>

                    <motion.path d={pathData4} fill="url(#movingGradient4)" />
                </svg>

                <svg className="core_svg5" width="232" height="196" viewBox="0 0 232 196">
                    <defs>
                        <motion.linearGradient
                            id="movingGradient5"
                            gradientUnits="userSpaceOnUse"
                            x1="-170"
                            y1="-170"
                            x2="248"
                            y2="258"
                        >
                            <animateTransform
                                attributeName="gradientTransform"
                                type="rotate"
                                values="-10 100 100; 0 100 100; 20 100 100"
                                dur={`${topCircleAnimationTime}s`}
                                repeatCount="indefinite"
                                calcMode="linear"
                                begin={`${svg5delay}s`}
                            />
                            <motion.stop
                                offset="0%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "0%" }}
                                animate={{ offset: ["0%", "100%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg5delay }}
                            />
                            <motion.stop
                                offset="50%"
                                stopColor="#bbbbbb"
                                initial={{ offset: "10%" }}
                                animate={{ offset: ["20%", "110%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg5delay }}
                            />
                            <motion.stop
                                offset="100%"
                                stopColor={bgSvgColor}
                                initial={{ offset: "30%" }}
                                animate={{ offset: ["30%", "120%"] }}
                                transition={{ duration: topCircleAnimationTime, repeat: Infinity, ease: "linear", delay: svg5delay }}
                            />
                        </motion.linearGradient>
                    </defs>

                    <motion.path d={pathData5} fill="url(#movingGradient5)" />
                </svg>

            </div>
        </div>
    );
};

export default CoreLoader;